import moment from 'moment';
export default (date_str, max_days_ago = 14) => {
    const momentDate = Number.isInteger(date_str) ? moment(date_str * 1000) : moment(date_str);
    if(Math.abs(momentDate.diff(moment(), 'days')) > max_days_ago)
      return `+${max_days_ago} days ago`;
    else 
      return `${momentDate.fromNow()}`;
}